import { render, staticRenderFns } from "./FloorAreaAttic.vue?vue&type=template&id=2d1d254c&"
import script from "./FloorAreaAttic.vue?vue&type=script&lang=ts&"
export * from "./FloorAreaAttic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports